import i18n from "../../../common/lang";
export const Columns = [
    { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', fixed: true, slot: true },
    { LabelName: i18n.t('lang.terminalList.terminalNumber'), row: 210, align: 'left', key: 1, ColumnsKey: 'subdomain', seek: 'subdomain', sort: 'custom' },
    { LabelName: i18n.t('lang.particulars.Serial'), row: 160, align: 'left', key: 2, ColumnsKey: 'sn', seek: 'sn', sort: 'custom' },
    { LabelName: i18n.t('lang.terminalList.name'), row: 160, align: 'left', key: 3, ColumnsKey: 'name', name: true, seek: 'name', sort: 'custom' },
    { LabelName: i18n.t('lang.terminalList.monitoringLocation'), row: 160, align: 'left', key: 4, ColumnsKey: 'deviceAddress' },
    { LabelName: i18n.t('lang.editVar.type'), row: 160, align: 'left', key: 5, ColumnsKey: 'type', seek: 'type', sort: 'custom' },
    { LabelName: i18n.t('lang.particulars.IP'), row: 160, align: 'left', key: 6, ColumnsKey: 'ip', seek: 'ip', sort: 'custom' },
    { LabelName: i18n.t('lang.particulars.mac'), row: 160, align: 'left', key: 7, ColumnsKey: 'mac' },
    {
        LabelName: i18n.t('lang.devicelist.statevoid'), row: 160, align: 'center', key: 8, ColumnsKey: 'state', isCustom: true, seek: 'state', select: true, selectOptions: [
            { value: 0, label: i18n.t('lang.devicelist.connected') },
            { value: 1, label: i18n.t('lang.devicelist.not') },
        ]
    },
    { LabelName: i18n.t('lang.terminalList.accessTime'), row: 160, align: 'center', key: 9, ColumnsKey: 'ts', type: true, sort: 'custom' },
]

export const ColuumnsButton = [
    { key: 0, type: 'primary', icon: 'el-icon-document-copy', Authority: 270, Fun: "copyUrl" },
    { key: 1, type: 'success', icon: 'icon-yuanchenghuizhen', Authority: 269, Fun: "showPage" },
    { key: 2, type: 'primary', icon: 'el-icon-edit', Authority: 270, Fun: "editDetail" },
    { key: 3, type: 'danger', type2: 'primary', icon: 'el-icon-view', Authority: 270, Fun: "showDetail", icon2: 'icon-ziyuanxhdpi', icon2ActiveKey: 'hide', icon2ActiveValue: '0' },
    { key: 4, type: 'danger', icon: 'el-icon-delete', Authority: 270, Fun: "deleteDetail", },
]
